import '../../styles/components/_object-lock.scss';
export default (($) => {
    console.log('UNTUCKit : Module : ObjectLock : loaded');
    const $unlockForm = $('#object-unlock-form');
    const $passwordError = $('.password-error span');
    const $passwordErrorActive = $('.password-error-active');
    const resetCartPassword = function () {
        console.log('UNTUCKit : Module : ObjectLock : resetCartLock : success');
        $.ajax({
            type: "POST",
            url: '/cart/update.js',
            data: { "attributes[unlock]": "" },
            success: function () {
                console.log('UNTUCKit : Module : ObjectLock : resetCartLock : success');
            },
            dataType: 'json'
        });
    };
    const bindUIActions = function () {
        console.log('UNTUCKit : Module : ObjectLock : bindUIActions');
        $unlockForm.on('submit', function (e) {
            console.log('UNTUCKit : Module : ObjectLock : collection-unlock-form : submit');
            e.preventDefault();
            $passwordError.css('visibility', 'hidden');
            const $this = $(this), password = $this.find('#unlock_id_password').val();
            if (password.length == 0) {
                $passwordError.css('visibility', 'visible');
                $passwordError.html('Password Required');
                return;
            }
            $.ajax({
                type: "POST",
                url: '/cart/update.js',
                data: { "attributes[unlock]": password },
                success: function () {
                    window.location.reload();
                },
                dataType: 'json'
            });
            return false;
        });
    };
    const init = function () {
        console.log('UNTUCKit : Module : ObjectLock : init');
        window.addEventListener('load', () => {
            bindUIActions();
        });
        if ($passwordErrorActive.length) {
            resetCartPassword();
        }
    };
    return { init };
})($);
